import { render, staticRenderFns } from "./picturelive.vue?vue&type=template&id=0fd7359a&scoped=true&"
import script from "./picturelive.vue?vue&type=script&lang=js&"
export * from "./picturelive.vue?vue&type=script&lang=js&"
import style0 from "./picturelive.vue?vue&type=style&index=0&id=0fd7359a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd7359a",
  null
  
)

export default component.exports